# GraphQL mutation to reposition a stageset in the list of stagesets
# which will affect which leads go into which stageset

#import "../fragments/stageset-basic.graphql"

mutation RepositionStageset($stagesetPositionPayload: RepositionStagesetInput!) {
    repositionStageset(input: $stagesetPositionPayload) {
        stagesets {
            ...StagesetBasic
        }
    }
}
